import clsx from 'clsx';
import React from 'react';

import s from './Typography.module.less';

export const Label: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, children, ...rest }) => (
  <div {...rest} className={clsx(s.label, className)}>
    {children}
  </div>
);

export const SemiBoldSpan: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, children, ...rest }) => (
  <span {...rest} className={clsx(s.semiBoldSpan, className)}>
    {children}
  </span>
);
